import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import React from 'react';
import styles from './Headers.module.scss';

interface IComponentSubHeaderProps {
    title?: string | ReactJSXElement;
    containerClassName?: string;
    rightSideComponent?: JSX.Element;
}

const ComponentSubHeader: React.FC<IComponentSubHeaderProps> = (props: IComponentSubHeaderProps) => (
    <div className={props.containerClassName ?? styles.component_subheader_container}>
        {props.title && (
            <h3 className={styles.component_subheader_main}>
                {props.title} {props.rightSideComponent && <div className={styles.master_flex_and_float_right}>{props.rightSideComponent}</div>}
            </h3>
        )}
    </div>
);

export default ComponentSubHeader;
